(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvytot-packs"] && !Shopify.designMode) return;
  try {
    
(function(){
  var items = document.querySelectorAll('#meet-the-packs .st-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('st-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    items.forEach(function(el){ io.observe(el); });
  } else {
    items.forEach(function(el){ el.classList.add('st-in'); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvytot-pdp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var bar = document.getElementById('st-sticky-bar');
  if (!bar) return;
  var atc = document.querySelector('.st-pdp__purchase');
  if (!atc || window.innerWidth > 749) return;
  bar.removeAttribute('aria-hidden');
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      bar.style.transform = e.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
    });
  }, { threshold: 0.1 });
  io.observe(atc);
  // Start hidden (main ATC visible on load)
  bar.style.transition = 'transform 0.25s ease';
  bar.style.transform = 'translateY(100%)';
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savvytot-proof"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.getElementById('st-proof-{{ section.id }}');
  if (!section) return;
  var items = section.querySelectorAll('.st-reveal');
  // Mark ready so CSS hides items — they'll animate in via observer
  document.body.classList.add('st-js-ready');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('st-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function(el){ io.observe(el); });
  } else {
    items.forEach(function(el){ el.classList.add('st-in'); });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
